"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.csrfToken = void 0;

/**
 * Get the CSRF token from the DOM
 * @returns {string} The CSRF token
 */
var csrfToken = function csrfToken() {
  var csrf = '';
  if (typeof window === 'undefined' || !window.document) return csrf;
  var element = document.querySelector('input#csrftoken');

  if (element !== null) {
    csrf = element.value;
  }

  return csrf;
};

exports.csrfToken = csrfToken;